import React, { useEffect, useState } from "react";
import "./LandingScreen.scss";
import RadialChart from "./RadialChat";
import { FaChartBar } from "react-icons/fa";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import TotalValue from "../../data/TotalData.json";
import NotifyPopup from "../../Model/NotifyPopup";

const LandingScreen = () => {
  const [loading, setLoading] = useState(true);
  const [showValue, setshowValue] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
      setTimeout(() => {
        setshowValue(false);
      }, 3000);
    }, 5000);
  });

  const totalCashImprovement =
    TotalValue &&
    TotalValue.filter((item) => item.PrimaryType === "Cash Improvement").reduce(
      (sum, item) => sum + parseFloat(item.TotalValue),
      0
    );

  const totalMargin =
    TotalValue &&
    TotalValue.filter((item) => item.PrimaryType === "Improve Margin").reduce(
      (sum, item) => sum + parseFloat(item.TotalValue),
      0
    );

  console.log(totalCashImprovement);
  console.log(totalMargin);

  const countOfRecommandations =
    TotalValue && Array.isArray(TotalValue)
      ? TotalValue.filter((item) => item.PrimaryType === "Cash Improvement")
          .length
      : 0;

  const countOfRecommandationsMargin =
    TotalValue && Array.isArray(TotalValue)
      ? TotalValue.filter((item) => item.PrimaryType === "Improve Margin")
          .length
      : 0;

  const data = [
    {
      title: "Improve Operating Margins",
      category: "Improve Margin",
      radialValue: 85,
      contain:
        "Enhancing profitability through cost control, overhead reduction, and pricing optimization by addressing inefficiencies in inventory, workforce expenses, and financial processes",
      review: "",
      recommendations: `${countOfRecommandationsMargin}`,
      amount: `$ ${totalMargin.toFixed(0)} Mn`,
      colorBar: "#08D6D9",
      colorText: "#D02166",
    },
    {
      title: "Improve Cash Flow",
      category: "Cash Improvement",
      radialValue: 60,
      contain:
        "Strengthening liquidity by optimizing accounts receivable and accounts payable cycles, improving payment terms, reducing overdue balances, and ensuring timely cash inflows and outflows",
      review: "",
      recommendations: `${countOfRecommandations}`,

      amount: ` $ ${totalCashImprovement.toFixed(0)} Mn`,
      colorBar: "#f32ebf",
      colorText: "#9d4fe4",
    },
    {
      title: "Process Optimizations",
      radialValue: 1,
      contain:
        "Identifying and resolving inefficiencies in financial and operational workflows using data analytics",
      review: "",
      recommendations: "0",
      amount: "$ 0 Mn",
      colorBar: "#7A0FD9",
      colorText: "#D01F65",
      category: "Process Optimizations",
    },
  ];

  const data2 = [
    {
      id: 1,
      title: "Governance",
      Recommendations: "0",
      des: "This use case outlines an inventory system with high-level, aggregated, and detailed views by SKU/Item, categorized into coverage buckets. ",
      link: "",
    },
    {
      id: 2,
      title: "ROI / Future Investment",
      Recommendations: "0",
      des: "This use case outlines an inventory system with high-level, aggregated, and detailed views by SKU/Item, categorized into coverage buckets. ",
      link: "",
    },
    {
      id: 3,
      title: "Risk Proofing",
      Recommendations: "0",
      des: "This use case outlines an inventory system with high-level, aggregated, and detailed views by SKU/Item, categorized into coverage buckets. ",
      link: "",
    },
    {
      id: 4,
      title: "Innovations",
      Recommendations: "0",
      des: "This use case outlines an inventory system with high-level, aggregated, and detailed views by SKU/Item, categorized into coverage buckets. ",
      link: "",
    },
  ];

  return (
    <div id="HomeScreen">
      {/* <div className="welcome">
        Welcome to the Food Supply Chain Analytics Platform, dedicated to
        optimizing supply chain operations for the US and Canadian markets.
        Select the link you'd like to focus on:
      </div> */}

      <div className="item-box">
        {data &&
          data.map((item, index) => {
            return (
              <div key={index} className="item">
                <span className="item-title">
                  {loading ? (
                    <Skeleton style={{ width: "300px" }} />
                  ) : (
                    item.title
                  )}
                </span>

                {loading ? (
                  <div
                    style={{
                      textAlign: "center",
                      paddingTop: "20px",
                      paddingBottom: "20px",
                    }}
                  >
                    <Skeleton
                      width={200}
                      height={200}
                      style={{ borderRadius: "30px" }}
                    />
                  </div>
                ) : (
                  <span>
                    <RadialChart
                      amount={item.amount}
                      colorBar={item.colorBar}
                      colorText={item.colorText}
                      radialValue={item.radialValue}
                    />
                  </span>
                )}
                <span className="item-contain">
                  {" "}
                  {loading ? (
                    <Skeleton count={3} width={440} />
                  ) : (
                    item.contain
                  )}{" "}
                </span>
                <span className="item-recommendations">
                  <b className="item-value">
                    {" "}
                    {loading ? (
                      <Skeleton width={50} />
                    ) : (
                      item.recommendations
                    )}{" "}
                  </b>{" "}
                  <span>
                    {loading ? <Skeleton width={200} /> : "Recommendations"}{" "}
                  </span>{" "}
                  <span>{loading ? <Skeleton width={50} /> : "🔥"}</span>
                </span>
                <span className="item-review">
                  {loading ? (
                    <Skeleton width={100} />
                  ) : (
                    <>
                      {item.title === "Process Optimizations" ? (
                        <NotifyPopup />
                      ) : (
                        <Link to={`/details?name=${item.category}`}>
                          Review
                        </Link>
                      )}
                    </>
                  )}
                </span>
              </div>
            );
          })}
      </div>

      <div className="item-small-box">
        {data2 &&
          data2.map((item, index) => {
            return (
              <div key={index} className="item-small">
                <div className="item-box-1">
                  <span className="item-box-2">
                    <span style={{ display: "grid", paddingTop: "1px" }}>
                      {loading ? (
                        <Skeleton width={40} height={20} />
                      ) : (
                        <FaChartBar
                          style={{ fontSize: "28px", color: "blue" }}
                        />
                      )}
                    </span>

                    {loading ? (
                      <Skeleton width={130} height={20} />
                    ) : (
                      <span className="item-box2-title">{item.title}</span>
                    )}
                  </span>
                  <span className="item-box-3">
                    {loading ? (
                      <Skeleton width={50} height={20} />
                    ) : (
                      <b>{item.Recommendations}</b>
                    )}{" "}
                    {loading ? (
                      <Skeleton width={160} height={20} />
                    ) : (
                      "Recommendations"
                    )}
                  </span>
                </div>
                <div></div>
                <div
                  style={{
                    display: "grid",
                    justifyContent: "center",
                    color: "blue",
                    fontWeight: "600",
                    fontSize: "18px",
                    textDecoration: "underline",
                  }}
                >
                  {loading ? (
                    <Skeleton width={90} />
                  ) : (
                    <>
                      {/* <Link to={`/details?name=${item.title}`}>Review</Link> */}
                      <NotifyPopup />
                    </>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default LandingScreen;
